import { BaseFormViewType, ILeftSidePave } from ".";
import { FormBaseType } from "../ReDoc";

type ResponseType<T> = {
	result: Array<T>;
	hasError: boolean;
	errorMessage: string;
};

export enum AttachType {
	/** Стандартное вложение */
	Default,
	/** Заметка */
	Notes,
	/** Вложение сгенерировано. Недоступно для выбора на формах. */
	Generated,
	/** 
	 * Вложение является SOAP-конвертом, сгенерированным системой.
	 * Недоступно для выбора на формах.
	*/
	Soap,
	/** Вложение является SOAP-конвертом, сгенерированным системой и может быть направлен в орган власти. */
	SoapSending,
	/** Вложение, получение от сторонних ИС. */
	Response,
	/**  Вложение, получение от сторонних ИС. */
	External,
	/** Скрытое вложение */
	Hidden
};

export type FileAttachmentType = {
	id: string,
	name: string;
	lastModified: Date,
	size: number,
	signed: boolean,
	metadata: {
	  title: string;
	  "content-type": string;
	}
};

export interface IAttachmentLeftSidePave extends ILeftSidePave {
	/** Подписано ли вложение. */
	signed: boolean;
	/** Корректна ли подпись. */
	signatureIsCorrect?: boolean;
	/** Запрошена ли подпись для данного вложения */
	requestedByCurrentUser: boolean;
	/** Тип вложения */
	type: AttachType;
	/** Размер файла */
	size: number;
	/** Ссылка на скачивание файла */
	link?: string;
	/** Дата последнего изменения файла */
	lastUpdated?: string;
};

export type AttachmentType = BaseFormViewType & {

	/** Идентификатор аттачмента.  */
	attachmentId: string;
	/** Заголовок. */
	title: string;
	authorName: string;
	/**  Имя последнего, кто внес изменения. */
	senderName: string;
	/**  Дата последнего изменения. */
	lastEdited: string;
	/**  Ссылка на изображение аватарки автора. */
	lastEditorAvatarLink: string;
	attachmentDate: string;
	/**  Имя аттачмента. */
	attachmentName: string;
	/**  Описание аттачмента. */
	attachmentDescription: string;
	/**  Ссылка на просмотр аттачмента. */
	attachmentViewLink: string;
	/**  Ссылка на редактирование аттачмента. */
	attachmentEditLink: string;
	/** Ссылка на превью аттачмента. */
	attachmentPreviewLink: string;
	/** Ссылка на скачивание аттачмента. */
	attachmentDownloadLink: string;
	error: string;
	signButtonTitle: string;
	/** Идентификатор дела-родителя */
	parentFileId: string;

	fileIsPublic: boolean;
	/** Доступна ли кнопка "Подписать". */
	signButtonEnabled: boolean;
	/** Есть ли предпросмотр */
	showAttachmentPreview: boolean;
	/** Доступность вариантов печати МФЦ штампов */
	mfcStampsEnabled: boolean;
	deleteEnable: boolean;

	/** Идентификаторы дочерних дел */
	childFiles: Record<string,string> | null;
	/** Список подписей */
	signatureList: Array<SignaturePaveType> | null;
	/** Список запрошенных подписей */
	requestedSignatureList: Array<RequestedSignaturePaveType> | null;
	/** Зависимые элементы компонента. */
	relatedAttachments: Array<RelatedItemType>;
	relatedTasks: Array<RelatedItemType>;
};

export type RelatedItemType = {
    key: string;
    value: string;
};

export enum SignatureStatuses {
    /** Не установлена. */
    NotSet = -1,
    /** Некорректна. */
    Invalid = 0,
    /** Корректна. */
    Valid = 1,
    /** Корректна, но нет доверия к сертификату. */
    ValidButNotTrust = 2
}

export interface SignaturePaveType {
	/** Идентификатор владельца подписи.  */
	signerId: string;
	/** Ссылка на аватарку автора подписи.  */
	avatarLink: string;
	/** Идентификатор подписи/системное имя */
	signId: string;
	/** Имя файла подписи (.sig).  */
	signAttachmentId: string;
	/** Имя владельца подписи.  */
	title: string;
	/** Электронный адрес владельца подписи.  */
	email: string;
	/** Дата подписания.  */
	createDate: string;
	/** Наименование организации владельца подписи.  */
	organization: string;
	/** Контактная информация.  */
	contactInfo: string;
	/** Ссылка на скачивание файла подписи (.sig).  */
	downloadSignLink: string;
	/** Ссылка на скачивание файла сертификата (.cer).  */
	downloadCertLink: string;
	/** Статус подписи  */
	signatureStatus: SignatureStatuses;
	/** информация из сертификата которым подписали вложение  */
	signCertificateInfo: SignerCertInfoType;
	/** Флаг показывает, что подпись запрашивалась через Госключ  */
	isGoskey: boolean;
};

/** информация из сертификата */
export type SignerCertInfoType = {
	/** Кем выдан сертификат, которым подписали вложение */
	issuerUserName: string;
	/** Кому выдан сертификат, которым подписали вложение */
	subjUserName: string;
	/** дата с которой действует сертификат, которым подписали вложение */
	createDateTime: string;
	/** дата до которой действует сертификат, которым подписали вложение */
	validUntilDateTime: string | null;
	/** Должность владельца подписи. */
	position: string;
	/** Организация владельца подписи. */
	organization: string;
	/** Отпечаток сертификата */
	thumbprint: string;
	/** Серийный номер сертификата */
	serialNumber: string;
};

export type RequestedSignaturePaveType = {
	/** Идентификатор владельца подписи. */
	signerId: string;
	/** Идентификатор того, кто запросил подпись */
	requestedBy?: string;
	/** Ссылка на аватарку владельца подписи. */
	avatarLink: string;
	/** Имя файла подписи (.sig). */
	signAttachmentId: string;
	/** Имя владельца подписи. */
	title: string;
	/** Электронный адрес владельца подписи. */
	email: string;
	/** Наименование организации владельца подписи. */
	organization: string;
	/** Контактная информация. */
	contactInfo: string;
	/** Флаг показывает, что подпись запрашивалась через Госключ */
	isGoskey: boolean;
	/** Флаг показывает, отказ пользователя от подписания документов в МП «Госключ» */
	isGoskeyRejectSign: boolean;
};

export type SaveAttachmentInfoType = {
    hasError: boolean;
	errorMessage: string;
    id: string;
    value: string;
};

export type AttachmentWithSignDataType = {
    hasError: boolean;
	errorMessage: string;
    viewModel: AttachmentType;
    signatureList: Array<SignaturePaveType>;
    requestedSignatureList: Array<RequestedSignaturePaveType>;
};

export type FileAttachmentResponseType = ResponseType<FileAttachmentType>;

/** Данные с клиента для формирования подписи. */
export type SignAttachmentInfoType = FormBaseType & {
	/** Само сохраняемое значение. */
    value?: string | null;
	/** Идентификатор аттачмента. */
    attachmentId: string;
	/** Отпечаток сертификата для подписи. */
    thumbprint: string;
	/** Подписанные данные. */
    digest?: string | null;
	/** Сертификат в base64. */
    certificate: string;
	/** Нужно ли добавить метку времени в подпись */
    addTimestamp: boolean;
};


/** View-model для окна выбора сертификата подписи. */
export type BrowseCertificateBaseViewType = {
	/** Заголовок окна выбора сертификата */
    certificateWindowLabel: string;
	/** Идентификатор дела. */
    fileId: string;
	/** Идентификатор компонента */
    componentId: string;
	/** Идентификатор вложения. */
    attachmentId: string;
	/** Подписанные данные. */
    digest: string;
	/** Подписанные данные для списка сущностей */
    digestArray: string;
	/** Подписанные данные. */
    digest2: string;
	/** Алгоритм для вычисления значения хэш. */
    hashAlgId: number;
	/** Маршрут до метода контроллера */
    controllerCallbackMethodName: string;
	/** Сертификат в base64. */
    certificate: string;
	/** Требуется подпись ЭП-ОВ, а не ЭП-СП */
    isOv: boolean;
	/** в случае true — подпись двух запросов одной выбранной подписью. Доступно только для подписи ЭП-ОВ */
    two: boolean;
	/** МР для подписей ЭП-СП и ЭП-ОВ */
    mR: string;
	/** Тэг для подиси ЭП-СП */
    signingTag: string;
	/** Требуется ли проставить ID при подписывании. Для ЭП-СП */
    withId: boolean;
	/** Добавить подпись в конец сущности. Для ЭП-СП */
    fillInTheEnd: boolean;
};

export type SignHashArgType = {
    fileId: string;
    attachmentId: string; 
    certificate: string; 
    thumbprint: string;
    hashAlgId?: number; 
    digest: string;
    componentId?: string;
	addTimestamp: boolean; 
}

export type SignAttachmentResultType = {
    hasError: boolean;
    errorMessage: string | null;
    recid: string;
    attachmentId: string;
    refreshtask: boolean;
    refreshattach: boolean;
    kickuser: boolean;
    revision: null | string;
};

export type PdfPrintParamsType = {
	fileId: string;
	page: number;
	x: number;
	y: number;
	attachmentId: string;
	signIds: Array<string>;
};
